<div mat-dialog-content>
  <div class="mat-dialog-content">
    <div class="head-modal-list">
      @if (data.type == 's') {
        <h2>Saturação</h2>
      }
      @if (data.type == 'g') {
        <h2>Glicemia</h2>
      }
      @if (data.type == 'b') {
        <h2>Pressão</h2>
      }
      @if (data.type == 't') {
        <h2>Temperatura</h2>
      }
      @if (data.type == 'h') {
        <h2>Pulso</h2>
      }
    </div>

    <div class="row">
      @for (item of data.listHistory; track item) {
        <div class="col-12 col-sm-12 col-md-12">
          <div class="body-modal-list">
            <span>
              <b>Usuário:</b> {{item.userName}}
            </span>
            <span>
              <b>Módulo:</b> {{item.moduleName}}
            </span>
            <span>
              <b>Data:</b> {{item.vitalsCheckDate | date: 'yyyy/MM/dd HH:mm:ss'}}
            </span>
            <span>
              <b>Valor:</b> {{item.value}}
            </span>
          </div>
        </div>
      }
    </div>
  </div>
</div>